
//export const API_BASE_URL = 'http://localhost:8081';
// export const API_BASE_URL = 'http://54.95.153.177';
// export const API_BASE_URL = 'https://stg-2chiiki.skillengine.jp';//SKILL-STG

/*****-------本番----------- */
// export const API_BASE_URL = 'https://2chiiki.ana.co.jp';//ANA-PROD
// export const WP_URL = process.env.REACT_APP_WP_URL ?? 'https://2chiiki.ana.co.jp';
/*****------------------ */

/*****-------STG----------- */
 export const API_BASE_URL = 'https://stg-2chiiki.ana.co.jp';//ANA-STG
 export const WP_URL = process.env.REACT_APP_WP_URL ?? 'https://stg-2chiiki.ana.co.jp';
/*****------------------ */

